import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { Lightbulb, Map } from "lucide-react";

export const Route = createFileRoute("/lab")({
  head: () => ({
    meta: [
      { title: "Viny Lab — Ideias e roadmap da comunidade" },
      { name: "description", content: "Sugira funcionalidades, vote nas melhores ideias e acompanhe o roadmap oficial da Viny Club." },
      { property: "og:title", content: "Viny Lab — Ideias e roadmap da comunidade" },
      { property: "og:description", content: "Ajude a construir a Viny Club: envie ideias, vote e acompanhe o roadmap." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: LabLayout,
});

const tabs = [
  { to: "/lab", label: "Ideias", icon: Lightbulb, exact: true },
  { to: "/lab/roadmap", label: "Roadmap", icon: Map, exact: false },
] as const;

function LabLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <AppShell>
      <div className="mx-auto max-w-6xl px-4 pb-16 pt-6 lg:px-8 lg:pt-10">
        <header className="mb-6 flex items-center justify-between">
          <div>
            <div className="mb-1 flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-primary">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" /> Viny Lab
            </div>
            <h1 className="font-display text-3xl font-bold tracking-tight lg:text-4xl">
              Feito com a comunidade
            </h1>
          </div>
        </header>
        <nav className="mb-6 inline-flex rounded-full border border-[color:var(--hairline)] bg-surface p-1">
          {tabs.map((t) => {
            const active = t.exact ? pathname === t.to : pathname.startsWith(t.to);
            const Icon = t.icon;
            return (
              <Link
                key={t.to}
                to={t.to}
                className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
                  active ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                <Icon className="h-3.5 w-3.5" /> {t.label}
              </Link>
            );
          })}
        </nav>
        <Outlet />
      </div>
    </AppShell>
  );
}
